<div class="spinner-border text-primary" role="status"></div>
